import apiClient from '../client';
import { APIResponse } from '@memriti/shared';

export interface Topic {
  id: number;
  name: string;
  description?: string;
  created_at: string;
  updated_at: string;
}

export interface Subtopic {
  id: number;
  name: string;
  description?: string;
  topic_id: number;
  created_at: string;
  updated_at: string;
}

export interface Microtopic {
  id: number;
  name: string;
  description?: string;
  subtopic_id: number;
  created_at: string;
  updated_at: string;
}

export const topicsService = {
  getTopics: async (): Promise<APIResponse<Topic[]>> => {
    const response = await apiClient.get('/api/v1/topics');
    return response.data;
  },

  getSubtopics: async (topicId: number): Promise<APIResponse<Subtopic[]>> => {
    const response = await apiClient.get(`/api/v1/topics/${topicId}/subtopics`);
    return response.data;
  },

  getMicrotopics: async (subtopicId: number): Promise<APIResponse<Microtopic[]>> => {
    const response = await apiClient.get(`/api/v1/subtopics/${subtopicId}/microtopics`);
    return response.data;
  },
};